module.exports = __webpack_public_path__ + "static/img/backgroundWhite.5fb7abe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/backgroundWhite.png
// module id = Q3Wx
// module chunks = 94